import PropTypes from "prop-types";
import classNames from "classnames";
import AudioPlayer from "../../../../AudioPlayer/AudioPlayer";
import classes from "./VoiceOrdersList.module.css";

const VoiceOrdersList = (props) => {
  const { voiceOrders } = props;

  return (
    <ul className={classes["voice-orders-list"]}>
      {voiceOrders.map((voiceOrder, index) => (
        <li key={index} className={classes["voice-orders-list__item"]}>
          <p className={classes["voice-orders-list__item-id-wrapper"]}>
            <span className={classes["voice-orders-list__item-id-text"]}>
              رقم الطلب #
            </span>
            <span
              className={classNames(
                classes["voice-orders-list__item-id"],
                "numeric-content"
              )}
            >
              {voiceOrder.orderId}
            </span>
          </p>
          <div className={classes["voice-orders-list__item-audio-wrapper"]}>
            <AudioPlayer src={voiceOrder.fileUrl} />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default VoiceOrdersList;

VoiceOrdersList.propTypes = {
  voiceOrders: PropTypes.arrayOf(
    PropTypes.shape({
      orderId: PropTypes.number,
      createdAt: PropTypes.string,
      fileUrl: PropTypes.string,
    })
  ),
};
